<div class="ItemBorder">
	<h4 style="text-align: center">Select Options</h4>

	<!--Info-->
	<div class="MainGrid2Col">
		<label>Total Staff to Reactivate:</label>
		<div>
			<label class="InfoText">{{ TotalStaffCount }}</label>
		</div>

		<label>Defined By Import:</label>
		<label class="InfoText">{{ ImportedCount }}</label>

		<label>Locked:</label>
		<label class="InfoText">{{ LockedCount }}</label>
	</div>

	<!--Options-->
	<div class="MainGrid2Col" style="max-width: 600px; margin-top: 15px">
		<label>Change Defined By:</label>
		<div class="TextGrid">
			<input type="checkbox" class="CHK" [(ngModel)]="ChangeDefinedBy" />
			<p class="WarningText">
				NOTE: This should ONLY BE USED as a TEMPORARY FIX if a district is fixing their import file and a staff member keeps getting deactivated. Staff
				members NOT IN IMPORT FILES usually do not work at the district anymore. Checking this option makes the person user-defined meaning they won't
				get deactivated by the import process, and you will have to MANUALLY deactivate them if they leave the district (or they will never lose access)
			</p>
		</div>

		<label>Unlock Accounts:</label>
		<div class="TextGrid">
			<input type="checkbox" class="CHK" [(ngModel)]="UnlockAccounts" />
			<p class="WarningText">Note: will email all of the users that are being unlocked</p>
		</div>
	</div>
</div>

<div class="Buttons">
	<button class="btn btn-primary" (click)="onReactivateStaff()">Reactivate Staff</button>
	<button class="btn btn-warning" style="margin-left: 5px" (click)="onClose()">Cancel</button>
</div>
